<template>
  <div class="row-edit-badge-section col-lg-12">
   <div class="col-lg-12 no-padding">
     <label>Add Remarks</label>
     <textarea rows="2" @input="changeRemarks()" v-model.trim="approve_remarks"></textarea>
   </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      cfields: {},
      approve_remarks: null,
    };
  },
  methods: {
    changeCustomfields(field) {
      const value = event.currentTarget.value;
      const cfields = this.cfields;
      cfields[field.name] = value;
      setTimeout(() => { this.$emit('customField', cfields); }, 1000);
    },
    changeRemarks() {
      this.$emit('approve_remarks', this.approve_remarks);
    },
  },
};
</script>
